import React from "react";

/**
 * Table cell component
 * @param {React.ReactNode} children - Cell content
 * @param {Object} style - Inline style overrides
 * @param {string} className - Optional CSS class
 * @param {boolean} isHeader - Whether this is a header cell
 * @param {Object} rest - Additional props passed to the <td> or <th>
 */
const DataTableCell = ({ children, style, className, isHeader = false, ...rest }) => {
  const baseStyle = {
  };

  if (isHeader) { 
    return (
      <th
        style={{ ...baseStyle,  ...style }}
        className={className}
        role="button"
        {...rest}
      >
        {children}
      </th>
    );
  }

  return (
    <td style={{ ...baseStyle, ...style }} className={className} {...rest}>
      {children}
    </td>
  );
};

export default DataTableCell;
